import { Card, Container, Content } from "./styles";

const Banner = () => {
  return (
    <Container>
      <Content>
        <h1>
          Advocacia Especializada para Resolver Seu Problema com Segurança
          Jurídica
        </h1>

        <Card>
          <p>
            Na Cassavia Advocacia, oferecemos soluções eficientes em Direito de
            Família, Sucessões, Acidentes de Trânsito, Direito Trabalhista,
            Direito Imobiliário e Direito do Consumidor.
          </p>
          <p>
            Nosso compromisso é defender seus direitos com transparência,
            estratégia e profissionalismo.
          </p>

          <button
            onClick={() => window.open("https://wa.me/5511994602852", "_blank")}
          >
            ENTRE EM CONTATO
          </button>
        </Card>
      </Content>
    </Container>
  );
};

export default Banner;
